import { useEffect, useState } from "react";
import { LoginType_Enum } from "services/authontication/enums";
import { OtpLogin } from "./otp";
import { Props } from "./types";
import { RiArrowGoBackLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import style from "./login.module.scss";
import { useErrorBoundary } from "react-error-boundary";
import Authontication from "services/authontication/services";

export const KioskLogin = ({ paltformType }: Props) => {
  const [loginType, setLoginType] = useState<LoginType_Enum>(null!);
  const navigate = useNavigate();
  const [isCaptcha, setIsCaptcha] = useState(false);
  const { showBoundary } = useErrorBoundary();
  const [errorMessage, setErrorMessaged] = useState<string[]>([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const resData = await Authontication.GetLoginSettings();
        if (resData.success) {
          if (resData.data) {
            setIsCaptcha(resData.data.showCaptcha);
          }
        } else {
          setErrorMessaged(resData.messages);
        }
      } catch (error: any) {
        console.log("🚀 ~ file: kioskLogin.tsx ~ fetch ~ error:", error);
        showBoundary(error);
      }
    };

    fetch();
  }, []);
  const handleNavigate = () => {
    navigate(-1);
  };
  return (
    <>
      <div
        className={style[`_kiosk-backButton-container`]}
        onClick={handleNavigate}
      >
        <span className={style["text"]}>بازگشت</span>
        <span className={style["icon"]}>
          <RiArrowGoBackLine />
        </span>
      </div>
      <OtpLogin
        loginType={loginType}
        setLoginType={setLoginType}
        paltformType={paltformType}
        usernamePasswordLogin={false}
        isCaptcha={isCaptcha}
      />
      {errorMessage && errorMessage.length !== 0 && (
        <div style={{ height: "100vh", textAlign: "center" }}>
          {errorMessage.map((x) => (
            <span>{x}</span>
          ))}
        </div>
      )}
    </>
  );
};
